// 气象站详情
export default {
    equipmentName: '设备名称',
    altitude: '海拔',
    firmwareVersion: '固件版本',
    position: '位置',
    windSpeed: '风速',
    windDirection: '风向',
    temperature: '温度',
    humidity: '湿度',
    airPressure: '气压',
    cumulativeTime: '累计时间',
    export: '导出',
    lastWeek: '最近一周',
    lastMonth: '最近一个月',
    lastThreeMonths: '最近三个月',
    time: '时间',
    northWind: '北风',
    northeastWind: '东北风',
    eastWind: '东风',
    southeastWind: '东南风',
    southWind: '南风',
    southwestWind: '西南风',
    weatWind: '西风',
    northwestWind: '西北风',
}